// removed by extract-text-webpack-plugin
module.exports = {"tight":"tight__2qO2a"};


//////////////////
// WEBPACK FOOTER
// ./components/PhysicalChanges/style.css
// module id = WqJV
// module chunks = 0